import React from 'react';

import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import techImage from '../../../../public/assets/tech.png';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-background via-card to-muted">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(49,130,206,0.1),transparent_50%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(49,130,206,0.05)_1px,transparent_1px),linear-gradient(to_bottom,rgba(49,130,206,0.05)_1px,transparent_1px)] bg-[size:4rem_4rem]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="text-center lg:text-left space-y-6 md:space-y-8">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-primary/10 rounded-full text-primary text-xs md:text-sm font-medium font-body">
              <Icon name="Sparkles" size={16} />
              <span>Supporting Enterprise Organizations Globally</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-headline text-foreground leading-tight">
              Technology Partnerships That Drive{' '}
              <span className="text-primary">Business Transformation</span>
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-muted-foreground font-body max-w-2xl mx-auto lg:mx-0">
              We don't just build software—we architect digital transformation. Devontis Technologies combines technical mastery with strategic thinking to deliver SaaS solutions that scale your business.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-4">
              <Button
                variant="default"
                size="lg"
                iconName="Calendar"
                iconPosition="right"
                onClick={() => window.location.href = '/contact'}
                className="w-full sm:w-auto">

                Start Your Transformation
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="PlayCircle"
                iconPosition="left"
                onClick={() => window.location.href = '/process'}
                className="w-full sm:w-auto">

                See How We Work
              </Button>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 pt-4 md:pt-6">
              <div className="text-center lg:text-left">
                <div className="text-2xl md:text-3xl font-bold font-headline text-foreground">50+</div>
                <div className="text-xs md:text-sm text-muted-foreground font-body">Projects Delivered</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-2xl md:text-3xl font-bold font-headline text-foreground">98%</div>
                <div className="text-xs md:text-sm text-muted-foreground font-body">Client Satisfaction</div>
              </div>
              <div className="text-center lg:text-left">
                <div className="text-2xl md:text-3xl font-bold font-headline text-foreground">24/7</div>
                <div className="text-xs md:text-sm text-muted-foreground font-body">Support Available</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <Image
                src="https://img.rocket.new/generatedImages/rocket_gen_img_1dfbc27cd-1766500363073.png"
                alt="Modern collaborative workspace with diverse team of software developers working on multiple monitors displaying code and design interfaces in bright office environment"
                className="w-full h-64 md:h-80 lg:h-96 object-cover" />

              {/* <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent" /> */}
            </div>

            {/* <div className="absolute -bottom-4 -left-4 md:-bottom-6 md:-left-6 bg-card border border-border rounded-xl p-4 md:p-6 shadow-lg max-w-xs">
              <div className="flex items-center space-x-3 mb-2">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-success/10 rounded-full flex items-center justify-center">
                  <Icon name="TrendingUp" size={20} color="var(--color-success)" />
                </div>
                <div>
                  <div className="text-lg md:text-xl font-bold font-headline text-foreground">2.5M+</div>
                  <div className="text-xs md:text-sm text-muted-foreground font-body">Revenue Generated</div>
                </div>
              </div>
            </div> */}

            <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 bg-card border border-border rounded-xl p-3 md:p-4 shadow-lg">
              {/* <div className="flex items-center space-x-2">
                <Icon name="Award" size={20} color="var(--color-primary)" />
                <span className="text-xs md:text-sm font-medium font-body text-foreground">ISO 27001 Certified</span>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <Icon name="ChevronDown" size={32} className="text-muted-foreground" />
      </div>
    </section>);

};

export default HeroSection;